export default "__VITE_ASSET__F9WAcDAL__"